import { Text } from '@react-pdf/renderer';

import { styles } from './styles';

export function List({ children }: { children: React.ReactNode }) {
  return <ul style={styles.list}>{children}</ul>;
}

export function ListItem({ children }: { children: React.ReactNode }) {
  return (
    <li>
      <Text>
        {'\u2022'} {children}
      </Text>
    </li>
  );
}
